import {Routes} from '@angular/router';
import {AdminLayoutComponent} from './layouts/admin/admin-layout.component';
import {AuthLayoutComponent} from './layouts/auth/auth-layout.component';
import {LoginComponent} from "./pages/login/login.component";

export const AppRoutes: Routes = [
    {
        path: '',
        redirectTo: 'pages/login',
        pathMatch: 'full',
    }, {

        path: '',
        component: AdminLayoutComponent,
        children: [
            {
                path: '',
                loadChildren: './dashboard/dashboard.module#DashboardModule'
            },  {
                path: 'reports',
                loadChildren: './reports/reports.module#ReportsModule'
            }, {
                path: 'charts',
                loadChildren: './charts/charts.module#ChartsModule'
            }, {
                path: 'calendar',
                loadChildren: './calendar/calendar.module#CalendarModule'
            }, {
                path: 'user',
                loadChildren: './userpage/user.module#UserModule'
            }, {
                path: 'timeline',
                loadChildren: './timeline/timeline.module#TimelineModule'
            },
            {
                path: 'crud',
                loadChildren: './crud/crud.module#CrudModule'
            },
            {
                path: 'business',
                loadChildren: './business/business.module#BusinessModule'
            },
            {
                path: 'stock',
                loadChildren: './stock/stock.module#StockModule'
            },
            {
                path: 'movement',
                loadChildren: './movement/movement.module#MovementModule'
            },
            {
                path: 'finances',
                loadChildren: './finances/finances.module#FinancesModule'
            }
        ]
    }, {
        path: '',
        component: AuthLayoutComponent,
        children: [{
            path: 'pages',
            loadChildren: './pages/pages.module#PagesModule'
        }
        ]
    },
];



// WEBPACK FOOTER //
// ./src/app/app.routing.ts